import { PROVISIONING_OVERALL_STATUS } from '@community_dev/types/lib/api/InfobipProvisioning'
import { Alert } from 'antd'
import type { JSX } from 'react'

type MasterPhoneNumberProps = {
  currentMasterNumber: string | null | undefined
  isMasterVoiceSetup: boolean | undefined
  provisioningStatus: string | undefined
}

const toAlertType = (
  status: string | undefined,
  hasMasterNumber: boolean,
  hasUnconfiguredVoice: boolean,
): 'success' | 'warning' | 'error' => {
  if (status === PROVISIONING_OVERALL_STATUS.ERROR) return 'error'
  if (status === PROVISIONING_OVERALL_STATUS.READY_FOR_TRAFFIC && hasMasterNumber && !hasUnconfiguredVoice) {
    return 'success'
  }
  return 'warning'
}

export const MasterPhoneNumber = ({
  currentMasterNumber,
  isMasterVoiceSetup,
  provisioningStatus,
}: MasterPhoneNumberProps): JSX.Element => {
  const masterMessage = currentMasterNumber
    ? `Master Phone Number: ${currentMasterNumber}`
    : 'Master Phone Number: Not set'
  const hasUnconfiguredVoice = !!currentMasterNumber && isMasterVoiceSetup === false

  return (
    <Alert
      description={
        hasUnconfiguredVoice ? (
          <ul style={{ marginBottom: 0, paddingLeft: '24px' }}>
            <li>Voice not configured</li>
          </ul>
        ) : undefined
      }
      message={masterMessage}
      showIcon
      type={toAlertType(provisioningStatus, !!currentMasterNumber, hasUnconfiguredVoice)}
    />
  )
}
